import ScoreMultiplyRewardCalculationTypeEditor from "../../../pages/actionModules/ActionModuleEditor/RewardCalculationEditor/ScoreMultiplyInputRewardCalculationTypeEditor";
import { RewardCalculationTypeDefinition } from "../actionModule";
import { BaseRewardCalculationType, isBaseRewardCalculationTypeModel, RewardCalculationType } from "./rewardCalculationType";

export interface ScoreMultiplyRewardCalculationTypeModel extends BaseRewardCalculationType {
    factor: number;
}

export function isScoreMultiplyRewardCalculationTypeModel(value: unknown): value is ScoreMultiplyRewardCalculationTypeModel {
    return (
        isBaseRewardCalculationTypeModel(value) &&
        value.type === RewardCalculationType.ScoreMultiplyRewardCalculationType &&
        "factor" in value &&
        typeof (value as ScoreMultiplyRewardCalculationTypeModel).factor === "number"
    );
}

export const ScoreMultiplyRewardCalculationType: RewardCalculationTypeDefinition = {
    name: "actionModules.rewardCalculationType.scoreMultiply.name",
    defaultValue: {
        factor: 2,
    },
    type: RewardCalculationType.ScoreMultiplyRewardCalculationType,
    editor: (props) => <ScoreMultiplyRewardCalculationTypeEditor {...props} />
};